import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class AxonNotificationModel extends SnModel {
  @Expose()
  public category: string;

  @Expose()
  public correlationId: string;

  @Expose()
  public deviceId: string;

  @Expose()
  public deviceModel: string;

  @Expose()
  public deviceType: string;

  @Expose()
  public id: string;

  @Expose()
  public notificationReceivedTime: number;

  @Expose()
  public source: string;

  @Expose()
  public timeOccurred: number;

  @Expose()
  public type: string;

  @Expose()
  public level: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
